import classNames from '@/utils/classNames';
import type { AnchorHTMLAttributes, HTMLAttributes, Ref } from 'react';
import { forwardRef } from 'react';
import type { FCC } from 'react-fc';
import styles from './NavTabs.module.css';

/** A tabs bar of links to other pages */
export const NavTabs: FCC<HTMLAttributes<HTMLElement>> = forwardRef(
    ({ children, className, ...rest }, ref: Ref<HTMLDivElement>) => (
        <nav ref={ref} className={classNames(styles.nav, className, 'cds-t-label cds-t-label--b')} {...rest}>
            <menu className={classNames(styles.navTabs)}>{children}</menu>
        </nav>
    )
);

export const NavTabsLink: FCC<AnchorHTMLAttributes<HTMLAnchorElement>> = forwardRef(
    ({ children, className, ...rest }, ref: Ref<HTMLAnchorElement>) => (
        <a ref={ref} className={classNames(styles.navTabsLink, className)} {...rest}>
            {children}
        </a>
    )
);
